export const ENABLE_APP_LOADING = 'ENABLE_APP_LOADING';
export const DISABLE_APP_LOADING = 'DISABLE_APP_LOADING';

export const SET_REQUEST_GLOBAL_LOADER = 'SET_REQUEST_GLOBAL_LOADER';

export const SET_AUTH_USER = 'SET_AUTH_USER';
export const CLEAR_AUTH_USER = 'CLEAR_AUTH_USER';
export const SET_AUTH_USER_SUCCESS = 'SET_AUTH_USER_SUCCESS';
export const SET_AUTH_USER_FAILURE = 'SET_AUTH_USER_FAILURE';
